import { getPosterUrl } from '@/mocks/imageUrls';

const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '采用最新CDN加速技术，视频加载快人一步。无论何时何地，点击即播，告别缓冲等待，畅享流畅观影体验。',
    imgSeq: 'feature-01',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持1080P超高清画质，画面细腻清晰。每一帧都经得起放大看，带给您影院级的视觉盛宴。',
    imgSeq: 'feature-02',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '收录超过10万部影视作品，涵盖电影、电视剧、综艺、动漫等多种类型，满足不同用户的观影需求。',
    imgSeq: 'feature-03',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '全面支持电脑、平板、手机等多种设备。一次收藏，多端同步，让你随时随地想看就看。',
    imgSeq: 'feature-04',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择奇优影院
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            我们致力于为您提供最优质的在线观影体验，让追剧成为一种享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-800/50 hover:bg-background-800 border border-background-700/30 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mb-4 rounded-lg bg-primary-500/10 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="text-foreground-900 font-bold text-lg mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}